import { NgModule } from '@angular/core';
import { MAT_LEGACY_DIALOG_DEFAULT_OPTIONS as MAT_DIALOG_DEFAULT_OPTIONS, MatLegacyDialogConfig as MatDialogConfig, MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';

import { SharedModule } from 'shared/module';
import { ModalCloseButton } from './close/close';
import { DescriptiveModal } from './descriptive/descriptive';
import { AlertModal } from './alert/alert';
import { MultiImageModal } from './image/multi/multi';
import { SingleImageModal } from './image/single/single';

@NgModule({
    providers: [
        // set configs for all modals
        { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: Object.assign(new MatDialogConfig(), {
            disableClose: true,
            maxWidth: '960px'
        })
        }
    ],
    declarations: [
        AlertModal,
        DescriptiveModal,
        MultiImageModal,
        ModalCloseButton,
        SingleImageModal
    ],
    exports: [
        AlertModal,
        MatDialogModule,
        DescriptiveModal,
        MultiImageModal,
        SingleImageModal,
        ModalCloseButton
    ],
    imports: [
        MatDialogModule,
        SharedModule
    ]
})
export class ModalModule {}
